export function markCurrentCenteredElementOnScroll(scrollableContainer, childrenSelector, alternateParentContainer = null) {

  if (!alternateParentContainer) {
    alternateParentContainer = scrollableContainer.parent;
  }
  if (typeof alternateParentContainer === 'string') {
    alternateParentContainer = scrollableContainer.closest(alternateParentContainer);
  }
  let markCenteredVisibleElement = (root, selector, alternateParentContainer = null) => {
    let children = (selector) ? root.querySelectorAll(selector) : [...root.children];

    let observer = new IntersectionObserver((entries, observer) => {
        children.forEach(el => el.classList.remove('current'));
        let currentElement = entries[0].target;
        currentElement.classList.add('current');
        (alternateParentContainer || currentElement.parentNode).dataset.currentPosition = Array.from(currentElement.parentNode.children).indexOf(currentElement);
      }, {
        root,
        rootMargin: '0px',
        threshold: 1.0
      }
    );
    children.forEach(el => observer.observe(el));
    return observer;
  };

  return markCenteredVisibleElement(scrollableContainer, childrenSelector, alternateParentContainer);
}

export function scrollToNextOrPreviousElement(scrollContainer, nextClickElement, prevClickElement) {
  const behavior = window.JS_SCROLL_BEHAVIOR;
  const currentShowedElement = () => {
    let current = scrollContainer.querySelector('.current')
    if (!current) {
      console.warn('Could not find .current on scrollable container');
      return null;
    }
    return current;
  }
  nextClickElement.addEventListener('click', (ev) => {
    let current = currentShowedElement()
    if (current?.nextElementSibling) {
      scrollContainer.scrollTo({
        left: scrollContainer.scrollLeft + current.clientWidth,
        behavior
      });
    } else {
      scrollContainer.scrollTo({
        left: 0,
        behavior
      });
    }
  })
  prevClickElement.addEventListener('click', (ev) => {
    let current = currentShowedElement()
    if (current?.previousElementSibling) {
      scrollContainer.scrollTo({
        left: scrollContainer.scrollLeft - current.clientWidth,
        behavior
      });
    } else {
      scrollContainer.scrollTo({
        left: scrollContainer.scrollWidth,
        behavior
      });
    }
  })
}